export default "__VITE_ASSET__OUiSF0tM__"